const responseStatus = function(response) {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response);
  } else {
    const err =
      response.statusText !== '' && response.type !== 'opaque'
        ? `${response.status}: ${response.statusText}`
        : 'Unknown error.';
    return Promise.reject(new Error(err));
  }
};
export { responseStatus };



// WEBPACK FOOTER //
// ./scripts/util/Fetch.js